import React from 'react';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  confirmButtonClass?: string;
  onConfirm: () => void;
  onCancel: () => void;
}
const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  message,
  confirmLabel,
  cancelLabel = 'Cancel',
  confirmButtonClass = 'bg-red-600 hover:bg-red-700',
  onConfirm,
  onCancel
}) => {
  return <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center" aria-labelledby="modal-title" role="dialog" aria-modal="true" data-id="element-225">
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-226">
        <div className="flex items-start justify-between p-4 border-b border-gray-200" data-id="element-227">
          <h3 id="modal-title" className="text-xl font-semibold text-gray-900 flex items-center" data-id="element-228">
            <AlertTriangleIcon className="h-5 w-5 text-amber-500 mr-2" aria-hidden="true" data-id="element-229" />
            {title}
          </h3>
          <button onClick={onCancel} className="text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md" aria-label="Close modal" data-id="element-230">
            <XIcon className="h-6 w-6" data-id="element-231" />
          </button>
        </div>
        <div className="p-6" data-id="element-232">
          <p className="text-gray-700" data-id="element-233">{message}</p>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200" data-id="element-234">
          <button type="button" className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 ${confirmButtonClass} text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm`} onClick={onConfirm} data-id="element-235">
            {confirmLabel}
          </button>
          <button type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" onClick={onCancel} data-id="element-236">
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>;
};
export default ConfirmModal;